import { render, staticRenderFns } from "./RiskOverrideSelector.vue?vue&type=template&id=79356ede&scoped=true"
import script from "./RiskOverrideSelector.vue?vue&type=script&lang=ts"
export * from "./RiskOverrideSelector.vue?vue&type=script&lang=ts"
import style0 from "./RiskOverrideSelector.vue?vue&type=style&index=0&id=79356ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79356ede",
  null
  
)

export default component.exports